import { render, staticRenderFns } from "./EmailHandlerForm.vue?vue&type=template&id=74181b8c&scoped=true&"
import script from "./EmailHandlerForm.vue?vue&type=script&lang=js&"
export * from "./EmailHandlerForm.vue?vue&type=script&lang=js&"
import style0 from "./EmailHandlerForm.vue?vue&type=style&index=0&id=74181b8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74181b8c",
  null
  
)

export default component.exports